import React, { useEffect, useState } from "react";
import SelectSearch, { fuzzySearch } from "react-select-search";
import {
  LineChart,
  Line,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";
import { getTxnvsViovsChrgbkBarChartDataAPI } from "../../common/apiService";
import Loader from "react-loader-spinner";
import { toast } from "react-toastify";
import { numberWithCommas } from "../../service/utilService";


const periodOpts = [
  { name: "Daily", value: "day" },
  { name: "Weekly", value: "week" },
  { name: "Monthly", value: "month" },
];

export default function TnxVsVioVsChargback({ selectedPlazaOpt, triggerBarChartApi}) {
  const [selectedPeriod, setSelectedPeriod] = useState("day");
  const [chartdata, setChartData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [plaza, setPlaza] = useState("");
  
  useEffect(() => {
    setPlaza(selectedPlazaOpt[0]?.value);
  }, [selectedPlazaOpt[0]?.value])
  
  useEffect (()=>{
    if(!loader)
    getTxnvsViovsChrgbkByOrder();
  }, [selectedPeriod, plaza, triggerBarChartApi])


  const getTxnvsViovsChrgbkByOrder = () =>{
    let headerJson = { 
      plazaIds: plaza || selectedPlazaOpt[0]?.value,
      order: selectedPeriod,
    }
    // if(!headerJson.plazaIds) return;
    setLoader(true);
    getTxnvsViovsChrgbkBarChartDataAPI(headerJson).then(res=>{
     const data = res.data.map(e=>({...e, chrgAmt1: Math.abs(e.chrgAmt)}))
      setChartData(data);
      setLoader(false);
    }).catch(err=>{
      setLoader(false);
      toast.warn(err?.res?.data?.message);
    })
  }

  function formatYAxis(value) {
    return numDifferentiation(value);
  }

  const numDifferentiation = (value) => {
    // var val = Math.abs(value);
    var val = value;
    if (val >= 10000000) {
      val = (val / 10000000).toFixed(2) + " Cr";
    } else if (val <= -10000000) {
      val = "-"+(Math.abs(val) /10000000).toFixed(2) + " Cr"
    } else if (val >= 100000) {
      val = (val / 100000).toFixed(2) + " Lac";
    } else if (val <= -100000) {
      val = "-"+(Math.abs(val) /100000).toFixed(2) + " Lac"
     } else if (val >= 1000) {
      val = (val / 1000).toFixed(2) + "K";
    } else if (val <= -1000) {
      val = "-"+(Math.abs(val) /1000).toFixed(2) + " K"
    }

    return val;
  };

 
  return (
    <div className="tnx-vio-chargback-chart-wrapper">
     
      <div className="flex">
        <p className="block-title">
          Txn Settlement Amt vs Violation Settlement Amt vs Chargeback Amt
        </p>
        <div className="dropdown-action trend_dropdown entry-point-plaza-lov avc-filter">
        <SelectSearch
          options={selectedPlazaOpt}
          search
          filterOptions={fuzzySearch}
          placeholder="Select Plaza"
          value={plaza}
          onChange={setPlaza}
          name="distanceBasedPlaza"
        />
          <SelectSearch
            options={periodOpts}
            search
            filterOptions={fuzzySearch}
            placeholder="Select period"
            value={selectedPeriod}
            onChange={setSelectedPeriod}
            name="Periods"
          />
        </div>
      </div>
      <br />
      {loader ? (
          <Loader style={{paddingLeft:'50%', paddingTop:'20%'}} type="ThreeDots" color="#9c1d26" width={100} visible={loader} />
        ) : (
      <>  
      {chartdata.length>0?(
      <ResponsiveContainer width="100%" height="90%">
        <LineChart
          width={600}
          height={300}
          data={chartdata}
          margin={{
            top: 15,
            right: 0,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="1" />
          <XAxis dataKey="period" dy={10}/>
          <YAxis tickFormatter={formatYAxis} tickMargin={10} yAxisId="left" width={120} label={{ value: "Txn Settlement Amt",  angle: -90, position: "insideLeft", dy: 45 ,dx: 20, stroke: "#B2ACAC",}}/>
          <YAxis tickFormatter={formatYAxis} tickMargin={10}  yAxisId="right" orientation="right" domain={[0,"auto"]} width={120} label={{ value: "Chargeback And Violation Amt",  angle: -90, position: "insideLeft", dy: 45 ,dx: 60, stroke: "#B2ACAC",}}/>
          <Legend content={renderLegend} />
          <Tooltip cursor={{ fill: "transparent" }} content={<CustomTooltip />} />
          <Line yAxisId="left" dataKey="trxAmt" stroke="#FDA629" strokeWidth={4}/>
          <Line yAxisId="right" dataKey="vioAmt" stroke="#DB3236" strokeWidth={4}/>
          <Line yAxisId="right" dataKey="chrgAmt1" stroke="#3d17e6" strokeWidth={4}/>
        </LineChart>
      </ResponsiveContainer>):
      (<p className="no-record-found">Record Not Found</p>)}
      </>  )}
    </div>
  );
}

const renderLegend = (props) => {
  const { payload } = props;
  const label = {
    trxAmt: "Txn Settlement Amt",
    vioAmt: "Violation Settlement Amt",
    chrgAmt1: "Chargeback Amt",
  };
  return (
    <div className="tnx-vio-chargback-chart-legend">
      {payload.map((entry, index) => (
        <div>
          <span
            className="color-dot"
            style={{ backgroundColor: entry.color }}
          ></span>
          &nbsp;
          <span key={`item-${index}`}>{label[entry.value]}</span>
        </div>
      ))}
    </div>
  );
};

const CustomTooltip = ({ active, payload, datakey }) => {
  if (active && payload) {
    const period = payload[0]?.payload.period;
    const trxAmt = payload[0]?.value;
    const vioAmt = payload[1]?.value;
    const chargeAmt = payload[2]?.payload.chrgAmt;
    return (
      <div className="line-chart_custom-tooltip">
        <p className="label">Period : {period}</p><br/>
        <p className="label">Net Settled Amt : {trxAmt+vioAmt+chargeAmt}</p><br/>
        <p className="label"><span className="color-dot" style={{ backgroundColor: payload[0].color }}></span> &nbsp; Txn Settlement Amt : {<>&#8377;{numberWithCommas(trxAmt, 2)}</>}</p>
        <p className="label"><span className="color-dot" style={{ backgroundColor: payload[1].color }}></span> &nbsp; Vio Settlement Amt : {<>&#8377;{numberWithCommas(vioAmt, 2)}</>}</p>
        <p className="label"><span className="color-dot" style={{ backgroundColor: payload[2].color }}></span> &nbsp; Chargeback Amt : {<>&#8377;{numberWithCommas(chargeAmt, 2)}</>}</p>
      </div>
    );
  }
  return null;
};
